<template>
  <v-dialog v-model="visible" max-width="800px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row dense>
            <v-col cols="12" md="6" lg="8">
              <v-select
                v-model="form.conceptoUniversidad"
                :items="conceptosUniversidades"
                item-value="id"
                item-text="concepto.nombre"
                label="Concepto Universidad"
                outlined
                dense
                hide-details
                clearable
                return-object
                :readonly="accion === accionesCrud.EDITAR || accion === 'cambiar-monto'"
                :disabled="accion === accionesCrud.EDITAR || accion === 'cambiar-monto'"
                @input="form.conceptoUniversidadId = form.conceptoUniversidad?.id"></v-select>

              <small v-for="error in errores.conceptoUniversidadId" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-text-field
                v-model="form.numeroCuotas"
                label="Número de cuotas"
                type="number"
                min="1"
                outlined
                dense
                hide-details
                clearable
                :readonly="accion === 'cambiar-monto'"
                :disabled="accion === 'cambiar-monto'"
                @input="generarDetallesPlanesPagosConceptosUniversidades"></v-text-field>

              <small v-for="error in errores.numeroCuotas" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-text-field
                v-model="form.montoTotal"
                label="Monto Total"
                type="number"
                min="1"
                step="0.01"
                outlined
                dense
                hide-details
                clearable
                @input="calcularMonto"></v-text-field>

              <small v-for="error in errores.montoTotal" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-text-field
                v-model="form.porcentaje"
                label="Porcentaje"
                type="number"
                min="1"
                max="100"
                outlined
                dense
                hide-details
                clearable
                @input="calcularMonto"></v-text-field>

              <small v-for="error in errores.porcentaje" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" md="6" lg="4">
              <v-text-field
                v-model="form.monto"
                label="Monto"
                type="number"
                min="1"
                step="0.01"
                outlined
                dense
                hide-details
                readonly
                disabled></v-text-field>

              <small v-for="error in errores.monto" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12">
              <h5>DETALLES DE PLANES DE PAGOS CONCEPTOS UNIVERSIDADES</h5>

              <v-divider class="my-2"></v-divider>
            </v-col>

            <v-col cols="12">
              <v-row dense>
                <v-col
                  cols="6"
                  v-for="(detalle, indice) in form.detallesPlanesPagosConceptosUniversidades"
                  :key="indice">
                  <v-row dense>
                    <v-col cols="4">
                      <v-text-field
                        v-model="detalle.numeroCuota"
                        label="Número de cuota"
                        type="number"
                        min="1"
                        readonly
                        outlined
                        dense
                        hide-details></v-text-field>
                    </v-col>

                    <v-col cols="8">
                      <v-text-field
                        v-model="detalle.monto"
                        label="Monto"
                        type="number"
                        min="0.01"
                        step="0.01"
                        outlined
                        dense
                        hide-details></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <v-row dense>
                <v-col cols="6">
                  <v-row dense>
                    <v-col cols="4">
                      <h5>TOTAL</h5>
                    </v-col>

                    <v-col cols="8">
                      <v-text-field
                        :value="totalDetalles"
                        color="primary"
                        type="number"
                        min="1"
                        step="0.01"
                        outlined
                        dense
                        :error-messages="
                          totalDetalles !== Number(form.monto)
                            ? ['El monto total no coincide con la suma de los montos de las cuotas']
                            : []
                        "
                        readonly></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          v-if="accion === accionesCrud.REGISTRAR"
          color="blue darken-1"
          text
          :disabled="enviando || totalDetalles !== Number(form.monto)"
          :loading="enviando"
          @click.prevent="validar">
          Agregar
        </v-btn>

        <v-btn
          v-else
          color="blue darken-1"
          text
          :disabled="enviando || totalDetalles !== Number(form.monto)"
          :loading="enviando"
          @click.prevent="abrirModalConfirmacion">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ConceptoUniversidadService from '../services/concepto-universidad.service';
import PlanPagoConceptoUniversidadService from '../services/plan-pago-concepto-universidad.service';
import ConfirmacionAccion from '../components/ConfirmacionAccion.vue';

export default {
  name: 'ModalFormularioPlanPagoConceptoUniversidad',
  mixins: [modalFormMixin, apiConsumerMixin],
  components: {
    ConfirmacionAccion,
  },
  props: {
    universidadId: {
      type: Number,
      default: null,
    },
    planPagoUniversidadId: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      conceptosUniversidades: [],
      accion: null,
      confirmacion: {
        titulo: 'Guardar Plan Pago Concepto Universidad',
        mensaje: '¿Está seguro de que desea guardar el Plan Pago Concepto Universidad?',
        realizandoAccion: false,
        fnAceptar: () => this.guardar(),
      },
    };
  },
  watch: {
    'form.conceptoUniversidadId': function () {
      this.errores.conceptoUniversidadId = [];
    },
    'form.numeroCuotas': function () {
      this.errores.numeroCuotas = [];
    },
    'form.montoTotal': function () {
      this.errores.montoTotal = [];
    },
    'form.porcentaje': function () {
      this.errores.porcentaje = [];
    },
    'form.monto': function () {
      this.errores.monto = [];
    },
    enviando: function () {
      this.confirmacion.realizandoAccion = this.enviando;
    },
  },
  computed: {
    totalDetalles() {
      return this.form.detallesPlanesPagosConceptosUniversidades.reduce((acc, curr) => acc + Number(curr.monto), 0);
    },
    titulo() {
      const nombreRecurso = this.nombreRecurso.toUpperCase();

      if (this.accion === 'cambiar-monto') {
        return `CAMBIAR ${nombreRecurso}`;
      }

      return this.form?.id ? `EDITAR ${nombreRecurso}` : `REGISTRAR ${nombreRecurso}`;
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        conceptoUniversidadId: null,
        conceptoUniversidad: null,
        orden: 1,
        numeroCuotas: 1,
        montoTotal: 1,
        porcentaje: 100,
        monto: 1,
        estaActivo: true,
        creadoEn: null,
        actualizadoEn: null,
        detallesPlanesPagosConceptosUniversidades: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        conceptoUniversidadId: data.conceptoUniversidadId,
        conceptoUniversidad: data.conceptoUniversidad,
        orden: data.orden,
        numeroCuotas: data.numeroCuotas,
        montoTotal: data.montoTotal,
        porcentaje: data.porcentaje,
        monto: data.monto,
        estaActivo: data.estaActivo,
        creadoEn: data.creadoEn,
        actualizadoEn: data.actualizadoEn,
        detallesPlanesPagosConceptosUniversidades: JSON.parse(
          JSON.stringify(data.detallesPlanesPagosConceptosUniversidades),
        ),
      };
    },
    abrir(accion, data = []) {
      this.accion = accion;

      Promise.all([this.obtenerConceptosUniversidades()]).then(() => {
        this.abrirMixin(accion, data);

        if (accion === this.accionesCrud.REGISTRAR) {
          this.generarDetallesPlanesPagosConceptosUniversidades();
        }
      });
    },
    abrirMixin(accion, data = null) {
      if (accion == this.accionesCrud.REGISTRAR) {
        this.form = this.generarObjetoFormRegistrar();
      }

      if (accion == this.accionesCrud.EDITAR || accion == 'cambiar-monto') {
        this.form = this.generarObjetoFormEditar(data);
      }

      this.errores = [];
      this.visible = true;
    },
    async obtenerConceptosUniversidades() {
      await this.obtenerDatosMixin(ConceptoUniversidadService.findAll, 'conceptosUniversidades', {
        universidadId: this.universidadId,
      });
    },
    validar() {
      if (
        !this.form?.conceptoUniversidadId ||
        !this.form?.conceptoUniversidad ||
        !this.form?.numeroCuotas ||
        !this.form?.montoTotal ||
        !this.form?.porcentaje ||
        !this.form?.monto
      ) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Los campos: Concepto Universidad, Orden, Número de cuotas, Monto Total, Porcentaje y Monto son obligatorios',
          type: 'error',
        });

        return;
      }

      if (this.planPagoUniversidadId) {
        this.guardarPlanPagoConceptoUniversidad();
      } else {
        this.agregarPlanPagoConceptoUniversidad();
      }
    },
    agregarPlanPagoConceptoUniversidad() {
      this.$emit('agregarPlanPagoConceptoUniversidad', this.form);
      this.cerrar();
    },
    calcularMonto() {
      this.form.monto = (this.form.montoTotal * (this.form.porcentaje / 100)).toFixed(2);

      [this.accionesCrud.EDITAR, 'cambiar-monto'].includes(this.accion)
        ? this.cambiarMontosDetallesPlanesPagosConceptosUniversidades()
        : this.generarDetallesPlanesPagosConceptosUniversidades();
    },
    generarDetallesPlanesPagosConceptosUniversidades() {
      this.form.detallesPlanesPagosConceptosUniversidades = [];

      const monto = this.form.monto;
      for (let i = 1; i <= this.form.numeroCuotas; i++) {
        const montoRedondeado = Math.round((this.form.monto / this.form.numeroCuotas) * 100) / 100;
        const montoCuota =
          i === this.form.numeroCuotas ? monto - montoRedondeado * (this.form.numeroCuotas - 1) : montoRedondeado;

        this.form.detallesPlanesPagosConceptosUniversidades.push({
          id: null,
          planPagoConceptoUniversidadId: null,
          numeroCuota: i,
          monto: montoCuota,
          creadoEn: null,
          actualizadoEn: null,
        });
      }
    },
    cambiarMontosDetallesPlanesPagosConceptosUniversidades() {
      const monto = this.form.monto;
      for (let i = 0; i < this.form.detallesPlanesPagosConceptosUniversidades.length; i++) {
        const montoRedondeado = Math.round((this.form.monto / this.form.numeroCuotas) * 100) / 100;
        const montoCuota =
          i === this.form.numeroCuotas - 1 ? monto - montoRedondeado * (this.form.numeroCuotas - 1) : montoRedondeado;

        this.form.detallesPlanesPagosConceptosUniversidades[i].monto = montoCuota;
      }
    },
    async editar() {
      await this.guardarDatosMixin(
        () => {},
        PlanPagoConceptoUniversidadService.update,
        this.accion,
        this.form,
        'Plan Pago Concepto Universidad',
        () => {
          this.cerrar();
          this.$emit('actualizarListado');
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    async guardarPlanPagoConceptoUniversidad() {
      await this.guardarDatosMixin(
        PlanPagoConceptoUniversidadService.create,
        () => {},
        this.accionesCrud.REGISTRAR,
        {
          ...this.form,
          planPagoUniversidadId: this.planPagoUniversidadId,
        },
        'Plan Pago Concepto Universidad',
        () => {
          this.cerrar();
          this.$emit('actualizarListado');
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    async cambiarMonto() {
      await this.guardarDatosMixin(
        () => {},
        PlanPagoConceptoUniversidadService.cambiarMonto,
        this.accionesCrud.EDITAR,
        {
          ...this.form,
          planPagoUniversidadId: this.planPagoUniversidadId,
        },
        'Plan Pago Concepto Universidad',
        () => {
          this.cerrar();
          this.$emit('actualizarListado');
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    abrirModalConfirmacion() {
      if (this.accion === this.accionesCrud.EDITAR) {
        this.confirmacion.titulo = 'Editar Plan Pago Concepto Universidad';
        this.confirmacion.mensaje =
          '¿Está seguro de que desea editar el Plan Pago Concepto Universidad? Si lo hace, se modificarán los datos del Plan Pago Concepto Universidad.';
      } else if (this.accion === 'cambiar-monto') {
        this.confirmacion.titulo = 'Cambiar Plan Pago Concepto Universidad';
        this.confirmacion.mensaje =
          '¿Está seguro de que desea cambiar-monto el Plan Pago Concepto Universidad? Si lo hace, se desactivará el Plan Pago Concepto Universidad actual y se creará uno nuevo con los datos ingresados. Esta acción no se puede deshacer.';
      }
      this.$refs.confirmacionRef.abrir();
    },
    guardar() {
      if (this.accion === this.accionesCrud.EDITAR) {
        this.editar();
      } else if (this.accion === 'cambiar-monto') {
        this.cambiarMonto();
      }
    },
  },
};
</script>